var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlasticCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 86,
    height: 57,
    viewBox: "0 0 86 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    width: 86,
    height: 57,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-2",
    "data-name": "SVGID",
    width: 86,
    height: 57,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plastic_card",
    "data-name": "plastic card",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27937",
    "data-name": "Group 27937"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31043",
    "data-name": "Path 31043",
    d: "M0,0H86.337V56.359H0Z",
    fill: "#1952a1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27933",
    "data-name": "Group 27933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27932",
    "data-name": "Group 27932",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27931",
    "data-name": "Group 27931",
    transform: "translate(-6.084 -36.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31044",
    "data-name": "Path 31044",
    d: "M153.754,16.614l-33.3-59.034,33.3-59.034,33.3,59.034Z",
    transform: "translate(-75.198 101.453)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3067",
    "data-name": "Ellipse 3067",
    cx: 35.039,
    cy: 36.327,
    rx: 35.039,
    ry: 36.327,
    transform: "translate(0 52.114)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31045",
    "data-name": "Path 31045",
    d: "M143.5,92.035a37.506,37.506,0,0,0,1.777-11.446,36.333,36.333,0,0,0-22.312-33.855l-2.508,4.447Z",
    transform: "translate(-75.198 7.852)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasticCard);
export default __webpack_public_path__ + "static/media/plastic_card.b1bce88a396824643ccee14db315c233.svg";
export { ForwardRef as ReactComponent };